module.exports = __webpack_public_path__ + "static/media/9_avatar.3e062db1.png";